import React, { useEffect } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";

interface DefaultFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  inputComponent: React.ReactElement;
  onClickNext?: () => void;
  label?: string;
  name?: string;
}

const DefaultField: React.FC<DefaultFieldProps> = (props) => {
  const { label, inputComponent, onClickNext, value, name, onChange } = props;
  const { t } = useTranslation();
  const onClickContinue = () => {
    if (onClickNext) onClickNext();
  };
  const unmasketPhoneValue = value?.replace(/[\s()_-]/g, "") || "";

  useEffect(() => {
    if (name === "phone") {
      dataLayerViewedEvent({
        ...tagManagerEvent.FreeAssessment.TELEPHONE_NEW_ASSESSMENT,
        version: "V3",
      });
    }
  }, [name]);

  const Footer = () => {
    return (
      <div className="footer">
        <Button
          className="botao-roxo"
          onClick={onClickContinue}
          disabled={!unmasketPhoneValue}
        >
          {t("quiz.pages.FreeAssessment.continue")}
        </Button>
      </div>
    );
  };

  return (
    <>
      <h1 style={{ marginTop: 54 }}>{label}</h1>
      <div className="full-item results">
        {React.cloneElement(inputComponent, {
          ...inputComponent.props,
          value,
          onChange,
        })}
      </div>
      <Footer />
    </>
  );
};

export default DefaultField;
